import { observer } from 'mobx-react-lite'
import { Box, Button, Icon, Typography } from 'shared/ui'
import { type ReviewAccountsStore } from 'pages/reviews/ui/ReviewAccounts'
import styles from './styles.module.scss'

interface IReviewAddAccountsContentProps {
  store: ReviewAccountsStore
}

export const ReviewAddAccountsContent = observer(({ store }: IReviewAddAccountsContentProps) => {
  const { allowedAccounts, showAddLinkModal } = store

  return (
    <div className={styles.allowedAccountsWrap}>
      {allowedAccounts.map((account) => (
        <div key={account.key} className={styles.allowedAccountsItem}>
          <div className={styles.allowedAccountsItemInner}>
            <div className={styles.iconWrap}>
              <Icon icon={account.icon} fontSize={20} />
            </div>
            <Typography variant={'button-small'} ariaLabel={'accountTitle'} ellipsis>
              {account.name}
            </Typography>
            <Box marginLeft={'auto'}>
              <Button
                text={'Add'}
                icon={'add'}
                size={'small'}
                contained={'primary'}
                onClick={() => {
                  showAddLinkModal(account)
                }}
              />
            </Box>
          </div>
        </div>
      ))}
    </div>
  )
})
